/*
 * Change color select
 * ----------------------------------------------- */
jQuery(window).on("load", function () {
  $("select option:first-child").text("選択してください");
  var select = $("select");
  if (select.length) {
    select.on("change", function () {
      $(this).addClass("changed");
    });
  }
});
